<template>
  <div class="carousel d-flex position-relative">
    <div
      v-if="isVisibleBtn"
      class="d-flex flex-column carousel-control-wrapper h-mr-5"
      :class="btnWrapperClass"
    >
      <AppIcon
        name="arrow-left"
        :width="arrowWidth"
        :fill="$scss.white"
        :rotate="isRTL ? -180 : 0"
        class="carousel-control cursor-hand h-100"
        :class="{ disable: isDisabledBtnPrev }"
        @click="scrollLeft"
      />
    </div>
    <HorizontalScroller
      ref="scroller"
      :scroll-speed="itemSize"
      class="carousel-wrapper"
      @update="scrollerUpdateHandler"
    >
      <ul class="d-flex align-items-start list-unstyled mb-0 h-100">
        <li
          v-for="(item, index) in items"
          :key="item.id"
          class="d-flex justify-content-center flex-shrink-0"
          :style="{ width: `${itemSize}px` }"
        >
          <slot name="carouselItem" v-bind="{ item, index, items }" />
        </li>
        <TextBlock
          v-if="!items.length"
          tag="li"
          variant="secondary"
          class="align-self-center"
          >{{ emptyText }}</TextBlock
        >
      </ul>
    </HorizontalScroller>
    <div
      v-if="isVisibleBtn"
      class="d-flex flex-column carousel-control-wrapper h-ml-5"
      :class="btnWrapperClass"
    >
      <AppIcon
        name="arrow-left"
        class="carousel-control cursor-hand h-100"
        :class="{ disable: isDisabledBtnNext }"
        :width="arrowWidth"
        :fill="$scss.white"
        :rotate="isRTL ? 0 : -180"
        @click="scrollRight"
      />
    </div>
  </div>
</template>
<script>
import AppIcon from '@/components/atoms/Icon';
import { mapGetters } from 'vuex';
import TextBlock from '@/components/atoms/TextBlock';
import HorizontalScroller from '@/components/common/HorizontalScroller';
import { prop } from '@/utils/factories';

export default {
  name: 'Carousel',
  components: {
    AppIcon,
    HorizontalScroller,
    TextBlock,
  },
  props: {
    items: prop(Array),
    itemSize: prop(Number, 70),
    arrowWidth: prop(Number, 32),
    emptyText: prop(String),
  },
  data() {
    return {
      btnHeight: 0,
      btnPaddingTop: 0,
      isVisibleBtn: false,
      isDisabledBtnPrev: false,
      isDisabledBtnNext: false,
    };
  },
  computed: {
    ...mapGetters(['isRTL']),
    btnWrapperClass() {
      return !this.btnHeight ? ['justify-content-center'] : '';
    },
  },
  watch: {
    items(newItems, oldItems) {
      if (newItems && oldItems && newItems.length !== oldItems.length) {
        this.$nextTick(this.$refs.scroller.update);
      }
    },
  },
  methods: {
    scrollerUpdateHandler({
      canBeScrolled,
      canBeScrolledLeft,
      canBeScrolledRight,
    }) {
      this.isVisibleBtn = canBeScrolled;
      this.isDisabledBtnNext = !canBeScrolledRight;
      this.isDisabledBtnPrev = !canBeScrolledLeft;
    },
    scrollLeft() {
      this.$refs.scroller.scrollLeft();
    },
    scrollRight() {
      this.$refs.scroller.scrollRight();
    },
  },
};
</script>
<style lang="scss" scoped>
.carousel {
  .carousel-control-wrapper {
    .carousel-control {
      background-color: $ph-input-bg;
      border-radius: $ph-small-radius;
    }
  }
  &.disable {
    opacity: 0.3;
    pointer-events: none;
  }
}
</style>
